import React, { useState } from "react";
import useForm from '../../../../../hooks/useForm';
import { FormField,  Modal, Button } from '@prosolve/common-components-ui'
import useDataHotels from '../../../../../dataHooks/useDataHotels'

export default ({
  hotel = {},
  eventId,
  onClose,
  onSuccess,
}) => {

  const {
    addNewHotel,
    updateHotel,
  } = useDataHotels()

  const formSchema = {
    requiredFields: ['personStaying', 'hotelName', 'address', 'hotelConfirmation', 'checkIn', 'checkOut'],
    optionalFields: ['cost'],
    initData: hotel
  };

  const formData = useForm(formSchema)

  const [isBusy, setIsBusy] = useState(false);

  const onClickSubmit = async () => {
    if (!isBusy && formData.isValid()) {
      setIsBusy(true)

      try {
        if (hotel._id) {
          await updateHotel({ _id: hotel._id, eventId, ...formData.values })
        } else {
          await addNewHotel({ eventId, ...formData.values })
        }

        setIsBusy(false)

        onSuccess()
      } catch (e) {
        console.log(e)
        setIsBusy(false)
      }
    }
  }

  const title = hotel._id ? 'Edit Lodging Reservations' : 'Add Lodging Reservations';

  const buttonText = hotel._id ? 'Edit Reservation' : 'Add Reservation';

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {buttonText}
      </Button>
    </div>
  )

  return (
    <Modal title={title} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='personStaying'
            type='text'
            label='Name(s)'
            placeholder='e.g. John Smith'
            formData={formData}
          />
        </div>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='hotelName'
            type='text'
            label='Hotel Name'
            placeholder='e.g. Marriott'
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='cost'
            type='currency'
            options={{ autoCommas: true }}
            label='Price'
            placeholder='Enter Amount (USD)'
            formData={formData}
          />
        </div>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='address'
            type='text'
            label='Address'
            placeholder='e.g. 1234 Cherry Blossom Way, Atlanta, GA 30309'
            formData={formData}
          />
        </div>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='hotelConfirmation'
            type='text'
            label='Confirmation Code'
            placeholder='e.g. CX15H4992'
            formData={formData}
          />
        </div>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='checkIn'
            type='date'
            label='Check In'
            placeholder='Select Date'
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='checkOut'
            type='date'
            label='Check Out'
            placeholder='Select Date'
            formData={formData}
          />
        </div>
      </div>
    </Modal>
  )
}